import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
  InMemoryBoolean,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from '@/plugins/i18n';

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const ReductionClausesHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "headers.reductionclauses.reduction",
    type: new InMemoryString("Percentage", {
      getString: (item, type) => {
      const value = parseFloat(item.Percentage);
      if (value === null || value === undefined || isNaN(value)) {
        if (item.FlatAmount!=null && item.FlatAmount !== undefined) {
          const val2 = parseFloat(item.FlatAmount);
          if (typeof val2 !== "number" || isNaN(val2)) {
            return item.FlatAmount;
          }
          return formatter.format(val2);
        }
        return "";
      }
      if (typeof value !== "number") {
        return item.Percentage;
      }
      return (parseFloat(item.Percentage*100)).toFixed(2) + "%";
    }}),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.age",
    type: new InMemoryString("Age"),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
];
export default ReductionClausesHeaders;
